// import i18n from '@/i18n/index';
import http from '@/services';
import mdModal from '@/components/BaseUi/MessageModal/src';
import loading from '@/components/BaseUi/LoadingModal';
import i18n from '@/i18n';
// import msgModal from '@/components/BaseUi/MessageModal/src';

// 创建session
export const handleCreateSession = function (data, callback) {
  createSession(data, callback);
};

export const createSession = async function (formData, callback) {
  loading.show();
  const { visaCardNum, visaCardName, cardNum, cdeDate } = formData;
  const { expiryMonth, expiryYear } = cdeDate;
  const res = await http.login.createSession();

  if (res.state === '11') {
    loading.hide();
    const sessionDetails = res.payload;
    const paymentDetails = {
      countryCode: 'US',
      currency: 'USD',
      isRecurring: false,
      locale: 'en_US',
      totalAmount: 0,
    };

    const cardNumber = visaCardNum;
    const name = visaCardName; // 不能是1位纯数字， 会提示length错误
    const cvv = cardNum;
    const date = expiryMonth + expiryYear;
    startSession(cardNumber, paymentDetails, cvv, date, sessionDetails, name, callback);
  } else {
    console.log('e', res.note);
    loading.hide();
  }
};

// 通过session获取对应的 Ingenico 加密字符串
export const startSession = function (
  cardNumber,
  paymentDetails,
  cvv,
  date,
  sessionDetails,
  cardholderName,
  callback,
) {
  loading.show();
  const sliceCardNumber = cardNumber.slice(0, 6);
  const connect = require('connect-sdk-client-js/dist/connectsdk.noEncrypt');
  // eslint-disable-next-line new-cap
  const session = new connect(sessionDetails);
  session.getIinDetails(sliceCardNumber, paymentDetails).then(
    iinDetailsResponse => {
      if (iinDetailsResponse.status !== 'SUPPORTED') {
        loading.hide();
        console.error(`Card check error: ${iinDetailsResponse.status}`);
        const errorMsg = `Card check error: ${iinDetailsResponse.status}`;
        showMessageModal({ desc: errorMsg, i18nNeed: false });
        return;
      }

      session
        .getPaymentProduct(iinDetailsResponse.paymentProductId, paymentDetails)
        .then(paymentProduct => {
          const paymentRequest = session.getPaymentRequest();
          paymentRequest.setPaymentProduct(paymentProduct);
          paymentRequest.setValue('cardNumber', cardNumber);
          paymentRequest.setValue('cvv', cvv);
          paymentRequest.setValue('expiryDate', date);
          paymentRequest.setValue('cardholderName', cardholderName);
          if (!paymentRequest.isValid()) {
            loading.hide();
            for (const error in paymentRequest.getErrorMessageIds()) {
              console.log('error', { error });
            }
          }

          // 获取加密字符串
          session
            .getEncryptor()
            .encrypt(paymentRequest)
            .then(
              paymentHash => {
                // 根据你是调用update card还是调用add new card传入对应的函数
                callback && callback(paymentHash);
              },
              errors => {
                console.log('errors123', { errors });
                mdModal.show({
                  image: false,
                  title: 'invalid-entry',
                  desc: 'please-check-details',
                  confirmBtn: 'ok',
                  justHide: true,
                  i18nNeed: true,
                });
                loading.hide();
              },
            );
        });
      // TODO
      //   .catch(e => {
      //   console.log('e', { e })
      //   mdModal.show({
      //     image: false,
      //     title: 'invalid-entry',
      //     desc: 'please-check-details',
      //     confirmBtn: 'ok',
      //     justHide: true,
      //     i18nNeed: true
      //   })
      // });
    },
    errors => {
      loading.hide();
      console.log('errors2', errors);
      const errorMsg = errors.json.errors[0].message;
      console.log('errorMsg', errorMsg);
      console.log("errorMsg === 'NO bin FOUND'", errorMsg === 'NO bin FOUND');
      if (errorMsg === 'NO bin FOUND') {
        showMessageModal({ desc: 'card-bin-no-eligible', i18nNeed: true });
      } else {
        showMessageModal({ desc: errorMsg, i18nNeed: false });
      }
    },
  );
};

// 展示错误信息弹窗
const showMessageModal = function (data) {
  mdModal.show({
    image: false,
    desc: data.i18nNeed ? i18n.t(data.desc) : data.desc,
    closeIcon: true,
    confirmBtn: 'ok',
    justHide: true,
  });
};
